export const assetImage = '';

export default assetImage;
